export function gapFilter(amount = 0, currency: string = '€') {
  if (amount === 0) {
    return '-'
  }

  const sign = amount >= 0 ? '+' : ''
  return sign + amount.toFixed(2).replace('.', ',') + currency
}
